import Cookies from 'universal-cookie';
import { getMainDomainUrl } from '~/utils/urlUtils';

const Cookie = new Cookies();

const ACCESS = 'access_token';
const REFRESH = 'refresh_token';

class Token {
    static setAccess(token, expire = 840) {
        // 14 mins expire time.
        Cookie.set(ACCESS, token, {
            expires: new Date(Date.now() + expire * 1000),
            path: '/',
            domain: getMainDomainUrl(), // Sets the domain to ".gethighered.global"
        });
    }

    static setRefresh(token, expire = 2592000) {
        // Lasts for 30 days (2592000 seconds)
        Cookie.set(REFRESH, token, {
            expires: new Date(Date.now() + expire * 1000),
            path: '/',
            domain: getMainDomainUrl(), // Sets the domain to ".gethighered.global"
        });
    }

    static remove() {
        // Attempts 10 times to remove the tokens. Just sometimes it does not, so this was necassary.
        let attempts = 0;
        while (attempts < 10 && (this.getAccess() || this.getRefresh())) {
            Cookie.remove(ACCESS);
            Cookie.remove(REFRESH);

            Cookie.remove(ACCESS, {
                path: '/',
                domain: getMainDomainUrl(),
            });
            Cookie.remove(REFRESH, {
                path: '/',
                domain: getMainDomainUrl(),
            });
            attempts++;
        }
    }

    static getAccess() {
        return Cookie.get(ACCESS);
    }

    static getRefresh() {
        return Cookie.get(REFRESH);
    }

    static isAuthenticated() {
        return Token.getAccess() !== undefined; // If there is an access-token, the user is authenticated
    }
}

export default Token;
